module.exports = __webpack_public_path__ + "img/type-h2.6e88007d.svg";